import { flagUrl } from './flags.js'

/** A round flag beside a country's name, in HTML. Nothing at all when there is no flag. */
export default function Flag({ iso2, size = 16, className = '' }) {
  const src = flagUrl(iso2)
  if (!src) return null
  return <img src={src} alt="" width={size} height={size} loading="lazy"
              className={`inline-block shrink-0 rounded-full ring-1 ring-black/10 object-cover ${className}`} style={{ width: size, height: size }} />
}

/** The same, inside an SVG chart: centred on (x, y). `id` must be unique on the page. */
export function SvgFlag({ iso2, x, y, size = 16, id }) {
  const src = flagUrl(iso2)
  if (!src) return null
  const r = size / 2
  return (
    <g pointerEvents="none">
      <clipPath id={id}><circle cx={x} cy={y} r={r} /></clipPath>
      <image href={src} x={x - r} y={y - r} width={size} height={size} clipPath={`url(#${id})`} preserveAspectRatio="xMidYMid slice" />
      <circle cx={x} cy={y} r={r} fill="none" stroke="rgba(0,0,0,.18)" strokeWidth="0.75" />
    </g>
  )
}
